/**
 * Stripe API
 */

import { apiFetch } from './config';

export interface CheckoutSession {
  sessionId: string;
  url: string;
}

export interface SubscriptionUpdate {
  success: boolean;
  message: string;
  newTier?: string;
}

export const stripeApi = {
  /**
   * Create checkout session for subscription
   */
  createCheckoutSession: async (tier: string, contributionMode: 'contributing' | 'private') => {
    return apiFetch<CheckoutSession>('/api/stripe/subscription/create', {
      method: 'POST',
      body: JSON.stringify({ tier, contributionMode }),
    });
  },

  /**
   * Update subscription (upgrade/downgrade)
   */
  updateSubscription: async (newTier: string) => {
    return apiFetch<SubscriptionUpdate>('/api/stripe/subscription/update', {
      method: 'PUT',
      body: JSON.stringify({ newTier }),
    });
  },

  /**
   * Cancel subscription
   */
  cancelSubscription: async () => {
    return apiFetch<{ message: string }>('/api/stripe/subscription/cancel', {
      method: 'DELETE',
    });
  },

  /**
   * Get billing portal URL
   */
  getBillingPortal: async () => {
    return apiFetch<{ url: string }>('/api/stripe/billing-portal', {
      method: 'POST',
    });
  },
};
